'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sampleFocusStateFromNewProps = exports.focusStateFromNewProps = exports.onChangeFocusSelection = exports.focusOptions = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _sampleFocusTypes;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _ = require('../');

var _constants = require('../constants');

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sampleFocusTypes = (_sampleFocusTypes = {}, (0, _defineProperty3.default)(_sampleFocusTypes, _constants.BAR, _constants.BAR), (0, _defineProperty3.default)(_sampleFocusTypes, _constants.ROW, _constants.ROW), (0, _defineProperty3.default)(_sampleFocusTypes, _constants.TIMELINE, _constants.TIMELINE), _sampleFocusTypes);

var focusComparator = function focusComparator(op1, op2) {
  return op1.value === op2.value;
};

var focusOptions = exports.focusOptions = function focusOptions(props, state, otherFocus, singularity) {
  if (!(0, _utils.hasFocus)(props.type)) {
    return [];
  }
  var options = (0, _.focus)(props.data, props.type, singularity, props.display);
  return R.differenceWith(focusComparator, options, R.prop(otherFocus, state));
};

var onChangeFocusSelection = exports.onChangeFocusSelection = function onChangeFocusSelection(_value) {
  var value = R.isNil(_value) ? [] : _value;
  return R.is(Array, value) ? value : [value];
};

var toKey = function toKey() {
  return R.prop('value');
};

var filterFocus = function filterFocus(focus, keyedOptions, type) {
  return R.reduce(function (acc, entry) {
    var entryKey = toKey(type)(entry);
    if (R.has(entryKey, keyedOptions)) {
      return R.append(R.prop(entryKey, keyedOptions), acc);
    }
    return acc;
  }, [], focus);
};

var focusStateFromNewProps = exports.focusStateFromNewProps = function focusStateFromNewProps(_ref, singularity, state) {
  var data = _ref.data,
      display = _ref.display,
      type = _ref.type;

  var _extractSdmxArtefacts = (0, _.extractSdmxArtefacts)(data),
      id = _extractSdmxArtefacts.id;

  var highlightState = R.propOr([], 'highlight', state);
  var baselineState = R.propOr([], 'baseline', state);
  var options = (0, _.focus)(data, type, singularity, display);
  var keyedOptions = R.indexBy(toKey(type), options);
  return {
    baseline: filterFocus(baselineState, keyedOptions, R.prop('type', state)),
    highlight: filterFocus(highlightState, keyedOptions, R.prop('type', state))
  };
};

/*
  This props/state parser which will be exposed in highlight/baseline properties,
  only deals for Bar and Row Chart (no chart dimension singularity involved).
  For other chart types, their own chart dimension singularity parser will handle focus management.
*/

var sampleFocusStateFromNewProps = exports.sampleFocusStateFromNewProps = function sampleFocusStateFromNewProps(props, state) {
  if (!R.has(props.type, sampleFocusTypes) || R.isNil(props.data)) {
    return {}; //no changes 
  }
  return focusStateFromNewProps(props, null, state);
};